import { defineStore } from 'pinia';
import type { FilterModalUiState } from '~~/types/vuex/FilterModalUi';

export const filterModalUiStore = defineStore('filterModalUi', {
  state: () => ({ isFilterModalOpen: false as FilterModalUiState['isFilterModalOpen'] | null }),
  actions: {
    setFilterModalOpen(payload: FilterModalUiState['isFilterModalOpen'] | null) {

      this.isFilterModalOpen = payload; 

    },
  },
});
